import { useEffect, useState, useSyncExternalStore } from 'react';
import { useRoomContext } from '@livekit/components-react';

import { localRecordingController, type LocalRecordingState } from './recorder';
import type { LocalRecordingSupport } from './support';

export type LocalRecording = LocalRecordingState & {
    support: LocalRecordingSupport;
    elapsedSeconds: number;
    start: () => Promise<void>;
    stop: () => Promise<void>;
};

export function useLocalRecording(): LocalRecording {
    const controller = localRecordingController(useRoomContext());
    const state = useSyncExternalStore(controller.subscribe, controller.getState);
    const [now, setNow] = useState(Date.now);

    useEffect(() => {
        if (state.startedAt === undefined) return;
        const interval = setInterval(() => {
            setNow(Date.now());
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, [state.startedAt]);

    return {
        ...state,
        support: controller.support,
        elapsedSeconds: state.startedAt === undefined ? 0 : Math.max(0, Math.floor((now - state.startedAt) / 1000)),
        start: controller.start,
        stop: controller.stop,
    };
}
